// extracted by mini-css-extract-plugin
export default {"serviceSection":"ServiceSection_serviceSection__Lu4X-"};